var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.22,153.12v94.66H201.34V159.46c0-22.17-7.93-37.31-27.8-37.31-15.16,0-24.17,10.19-28.15,20.06-1.44,3.53-1.81,8.43-1.81,13.38v92.19H88.69s.74-149.58,0-165.07h54.89v23.4c-.11.18-.27.36-.36.54h.36v-.54c7.29-11.23,20.3-27.27,49.46-27.27,36.11,0,63.18,23.59,63.18,74.28ZM31.28,3.15C12.5,3.15.22,15.47.22,31.66c0,15.85,11.93,28.53,30.34,28.53h.35C50.05,60.19,62,47.51,62,31.66,61.59,15.47,50.05,3.15,31.28,3.15ZM3.48,247.78H58.35V82.71H3.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.9a6c7ffb.svg";
export { ForwardRef as ReactComponent };